import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

export type GetCustomerBookingsExportParams = {
  customerId: string;
  fromDate: string;
  toDate: string;
};

function getCustomerBookingsExport(params: GetCustomerBookingsExportParams): Promise<Blob> {
  return getSMPBackendAPIAdmin().customersControllerDownloadCustomerBookingsV1(params.customerId, {
    fromDate: params.fromDate,
    toDate: params.toDate,
  });
}

export function useCustomerBookingsExport() {
  return useMutation({ mutationFn: getCustomerBookingsExport });
}
